import React from "react";
import styles from "./ContentBox.module.scss";
import HeaderMobile from "./HeaderMobile/HeaderMobile";
import classNames from "classnames";
import Scroll from "../../../services/Scroll";
import Slide from "@material-ui/core/Slide";
import Body from "./Body/Body";

class ContentBox extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      currentLawyer: this.props.currentLawyer,
      isOpen: this.props.isOpen,
      lawyerChabnged: true,
    };
  }

  componentDidMount() {
    if (
      this.props.type != "appointment" &&
      this.props.type != "blog" &&
      window.screen.availWidth > 768
    )
      Scroll.setLeftSide();
  }
  componentWillUnmount() {
    if (document.body.classList.contains("twoWindows"))
      document.body.classList.remove("twoWindows");
  }

  componentDidUpdate(prevProps) {
    // if(window.screen.availWidth > 768)
    //     Scroll.setLeftSide();
    if (
      prevProps.currentLawyer !== null &&
      prevProps.currentLawyer !== this.props.currentLawyer
    ) {
      this.setState({
        lawyerChabnged: false,
      });
      setTimeout(() => {
        this.setState({
          lawyerChabnged: true,
        });
        // const cbAnchor = document.querySelector('#cbAnchor');
        // if(cbAnchor)
        //     cbAnchor.scrollIntoView({behavior: "smooth",block: "start"});
      }, 100);
    }

    if (
      prevProps.isOpen &&
      this.props.isOpen &&
      ((this.props.children && prevProps.children !== this.props.children) ||
        (this.props.step && prevProps.step !== this.props.step))
    ) {
      const foundError = document.querySelector("#contetnBox .Mui-error");

      if (foundError)
        foundError.scrollIntoView({ behavior: "smooth", block: "center" });
      else {
        const cbAnchor = document.querySelector("#cbAnchor");
        if (cbAnchor)
          cbAnchor.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }

  displayContentBox = () => {
    const { isOpen, children, title, subtitle, step, maxStep } = this.props;
    return (
      <div
        className={classNames({
          [styles.ContentBox]: true,
          [styles.isOpen]: isOpen,
        })}
        id="contetnBox"
      >
        <HeaderMobile
          title={title}
          subtitle={subtitle}
          step={step}
          maxStep={maxStep}
          setBoxContent={this.props.setBoxContent}
          type={this.props.type}
          onClose={this.props.onClose}
        />
        <Slide
          timeout={{ enter: 200, exit: 0 }}
          direction="left"
          in={this.state.lawyerChabnged}
        >
          <Body
            isOpen={this.props.isOpen}
            setBoxContent={this.props.setBoxContent}
            title={this.props.title}
            subtitle={this.props.subtitle}
            step={this.props.step}
            maxStep={maxStep}
            bottomContent={this.props.bottomContent}
            currentLawyer={this.props.currentLawyer}
            changeBody={this.props.changeBody}
            boxContentLawyerInfo={this.props.boxContentLawyerInfo}
            imageUrl={this.props.imageUrl}
            type={this.props.type}
          >
            {children}
          </Body>
        </Slide>
      </div>
    );
  };

  render() {
    const { isOpen } = this.props;

    if (document.body.classList.contains("twoWindows"))
      document.body.classList.remove("twoWindows");

    if (isOpen) {
      document.body.classList.add("twoWindows");
    } else return null;

    if (window.screen.availWidth > 768)
      return (
        <Slide direction="left" in={isOpen}>
          {this.displayContentBox()}
        </Slide>
      );
    else return <div>{this.displayContentBox()}</div>;
  }
}

ContentBox.defaultProps = {};

export default ContentBox;
